import React from 'react';
import { Mail } from 'lucide-react';
import { TikTokIcon } from './icons/TikTokIcon';

type SocialType = 'email' | 'tiktok';

interface SocialLinkProps {
  type: SocialType;
  href: string;
  label: string;
}

export function SocialLink({ type, href, label }: SocialLinkProps) {
  return (
    <a
      href={href}
      target={type === 'email' ? undefined : '_blank'}
      rel={type === 'email' ? undefined : 'noopener noreferrer'}
      className="flex items-center gap-2 hover:text-rose-400 transition-colors"
    >
      {type === 'email' ? (
        <Mail className="w-5 h-5" />
      ) : (
        <TikTokIcon className="w-5 h-5" />
      )}
      {label}
    </a>
  );
}